
import api from "../utils/axios";

export const getFaqs = async () => {
    const response = await api.get("/api-faqs");

    return response.data;
};
